import React from 'react';
import { grey_1100, grey_400 } from '@fiverr-private/sass/helpers';
import { translate } from '@fiverr-private/i18n-react';
import { BadgeProps } from '../../types';
import Badge from '../Badge';
import SellerLevelDiamondIcon from '../SellerLevelDiamondIcon';

import styles from './index.module.scss';

const SellerLevelOneBadge = ({
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
}: BadgeProps) => (
  <Badge
    showTooltip={showTooltip}
    color={grey_1100}
    backgroundColor="transparent"
    tooltipContent={translate('badges.seller_level_one_badge.tooltip')}
    tooltipPosition={tooltipPosition}
    dataTestId={dataTestId}
    appendTooltipToBody={appendTooltipToBody}
    disableTooltipFlip={disableTooltipFlip}
    disablePadding={true}
  >
    <div className={styles.wrapper}>
      <p>Level 1</p>
      <div className={styles.iconsContainer}>
        <SellerLevelDiamondIcon />
        <SellerLevelDiamondIcon color={grey_400} />
        <SellerLevelDiamondIcon color={grey_400} />
      </div>
    </div>
  </Badge>
);

SellerLevelOneBadge.displayName = 'SellerLevelOneBadge';

export default SellerLevelOneBadge;
